export const getCompanySeatsSelector = (state: any) => state.seatsReducer.seats;
export const getSeatSelector = (state: any, seatId: string) =>
  state.seatsReducer.seats.find((seat: any) => seat.id === seatId);
